import React from "react";
import InspectionShell from "../InspectionShell";
import RotateDeviceGraphic from "../RotateDeviceGraphic";
import "./style.css";

export default function RotateDeviceScreen({
  badge = "Rotate device",
  title = "Turn your device sideways",
  description = "This step works best in landscape mode. Rotate your phone to continue.",
  onBack,
}) {
  return (
    <InspectionShell
      mainClassName="pi-inspection-main--center pi-inspection-main--rotate"
      badge={badge}
      onBack={onBack}
      showFooter={false}
      className="pi-inspection-page--app"
    >
      <div className="pi-inspection-status-card pi-inspection-status-card--rotate">
        <p className="pi-inspection-label">{badge}</p>
        <div className="pi-inspection-status-card__hero pi-inspection-status-card__hero--rotate">
          <RotateDeviceGraphic />
        </div>
        <div className="pi-rotate-hint" aria-hidden="true">
          <span className="pi-rotate-hint__badge">Portrait</span>
          <span className="pi-rotate-hint__arrow">→</span>
          <span className="pi-rotate-hint__badge pi-rotate-hint__badge--active">
            Landscape
          </span>
        </div>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </InspectionShell>
  );
}
